/*******************************************************************************
TRIGGER HORIZONTAL SCROLL USING LEFT/RIGHT ARROWS
*******************************************************************************/

export default function triggerScrollOnClick(e) {
    const $arrowButton = $(e.currentTarget);
    const $scrollableArea = $arrowButton.siblings('.scroll-tabs');

    // Figure out which arrow was clicked
    const isLeft = $arrowButton.hasClass('nav-arrow-left');

    // Stop the click event from triggering on the nav item below the arrow
    e.stopPropagation();

    const currentScrollPos = $scrollableArea.scrollLeft();

    if (isLeft) { $scrollableArea.animate({ scrollLeft: currentScrollPos - 200 }, 400); }
    if (!isLeft) { $scrollableArea.animate({ scrollLeft: currentScrollPos + 200 }, 400); }
}
